import {
  FRONTEND_ABOUT_US_URL,
  FRONTEND_CHALLENGES_URL,
  FRONTEND_COURSES_URL,
  FRONTEND_DASHBOARD_URL,
  FRONTEND_DISCUSS_URL,
  FRONTEND_LIVE_SESSIONS_URL,
  FRONTEND_LOGIN_URL,
  FRONTEND_NOTEBOOKS_URL,
  FRONTEND_PROFILE_EDIT_EMAIL_URL,
  FRONTEND_PROFILE_EDIT_PASSWORD_CHANGE_URL,
  FRONTEND_PROFILE_EDIT_SOCIAL_ACCOUNTS,
  FRONTEND_PROFILE_EDIT_URL,
  FRONTEND_SIGNUP_URL,
  FRONTEND_WALL_OF_LOVE_URL,
} from 'common/utils/constants';

export const appRoutes = [
  {
    id: 1,
    label: 'Courses',
    route: FRONTEND_COURSES_URL,
    isReactLink: true,
  },
  {
    id: 2,
    label: 'Challenges',
    route: FRONTEND_CHALLENGES_URL,
    isReactLink: true,
  },
];

export const bootcampData = [
  {
    id: 15,
    label: 'View All Bootcamps',
    route: '/bootcamps',
    isReactLink: false,
  },
];

export const sideBarAppRoutes = [
  {
    id: 1,
    label: 'AI Marketplace',
    route: 'https://aimarketplace.co/',
    isReactLink: false,
    target: '_blank',
  },
  {
    id: 2,
    label: 'AI Planet For Teams',
    route: '/teams',
    isReactLink: false,
  },
  {
    id: 10,
    label: 'About Us',
    route: FRONTEND_ABOUT_US_URL,
    isReactLink: false,
  },
  {
    id: 9,
    label: 'Wall Of Love',
    route: FRONTEND_WALL_OF_LOVE_URL,
    isReactLink: false,
  },
  {
    id: 7,
    label: 'Discuss',
    route: FRONTEND_DISCUSS_URL,
    isReactLink: false,
    target: '_blank',
  },
];

export const additionalSettingsRoutes = [
  {
    id: 1,
    label: 'Basic Info',
    route: FRONTEND_PROFILE_EDIT_URL,
    isReactLink: false,
  },
  {
    id: 2,
    label: 'Email Settings',
    route: FRONTEND_PROFILE_EDIT_EMAIL_URL,
    isReactLink: false,
  },
  {
    id: 3,
    label: 'Social Accounts',
    route: FRONTEND_PROFILE_EDIT_SOCIAL_ACCOUNTS,
    isReactLink: false,
  },
  {
    id: 4,
    label: 'Change Password',
    route: FRONTEND_PROFILE_EDIT_PASSWORD_CHANGE_URL,
    isReactLink: false,
  },
];

export const sidebarNavActions = [
  {
    id: 1,
    label: 'Login',
    route: FRONTEND_LOGIN_URL,
    isReactLink: false,
  },
  {
    id: 2,
    label: 'Join For Free',
    route: FRONTEND_SIGNUP_URL,
    isReactLink: false,
  },
];

export const profileData = [
  {
    id: 2,
    label: 'Dashboard',
    route: FRONTEND_DASHBOARD_URL,
    isReactLink: false,
  },
  {
    id: 3,
    label: 'Additional Settings',
    route: FRONTEND_PROFILE_EDIT_URL,
    isReactLink: false,
  },
];

export const moreData = [
  {
    id: 1,
    label: 'Notebooks',
    route: FRONTEND_NOTEBOOKS_URL,
    isReactLink: true,
  },
  {
    id: 2,
    label: 'Live Sessions',
    route: FRONTEND_LIVE_SESSIONS_URL,
    isReactLink: true,
  },
  {
    id: 3,
    label: 'Discuss',
    route: FRONTEND_DISCUSS_URL,
    isReactLink: false,
    target: '_blank',
  },
];

export const challengesData = [
  {
    id: 1,
    route: `${FRONTEND_CHALLENGES_URL}/#active`,
    label: 'Active/Upcoming',
    isReactLink: true,
  },
  {
    id: 2,
    route: `${FRONTEND_CHALLENGES_URL}/#past`,
    label: 'Practice',
    isReactLink: true,
  },
];
